<mat-card appearance="outlined" *ngIf="load">
  <div>
    <div class="load__main-info tw-flex tw-gap-x-8">
      <a
        [routerLink]="'/dashboard/shipment-load/main-info'"
        [queryParams]="{
          loadNumber: load.loadNumber,
          monitoringPageType: monitoringPageType
        }"
      >
        <h3 class="load__number card-item-number link" cropText>
          {{ 'monitoring.transports.viewMode.load' | translate }}:
          {{ load.loadNumber }}
        </h3>
      </a>
      <ng-container *ngIf="load.isCancelled; else deviationType">
        <span class="cancelled-label">{{ 'common.field.cancelled' | translate }} </span>
      </ng-container>

      <ng-template #deviationType>
        <ui-deviation-type *ngIf="load?.deviation as deviation" [deviation]="deviation"></ui-deviation-type>
      </ng-template>

      <div class="load__transport-mode" cropText>
        <ui-transport-mode [mode]="load?.transportMode" [showText]="false"></ui-transport-mode>
      </div>

      <ui-status-code
        [statusCode]="load.webLoadStatusView?.statusCode"
        [statusDescription]="load.webLoadStatusView?.statusDescription"
        cropText
      ></ui-status-code>

      <div *ngIf="!load.isCancelled" class="load__status" cropText>
        <div class="item-status">
          {{ load.status | startCase }}
        </div>
      </div>
      <ui-dates class="load__dates" cropText [dates]="load.dates" [dateType]="dateType.Departure"></ui-dates>
      <ui-dates class="load__dates" cropText [dates]="load.dates" [dateType]="dateType.Arrival"></ui-dates>
    </div>
    <div class="load__details">
      <ng-container
        *ngFor="
          let item of [
            {
              title: 'common.field.carrier' | translate,
              rows: [
                {
                  label: 'common.field.id' | translate,
                  text: load.carrierId
                },
                {
                  label: 'monitoring.transports.loadView.name' | translate,
                  text: load.carrierName
                }
              ]
            },
            {
              title: 'monitoring.transports.loadView.pickup' | translate,
              rows: [
                {
                  label: 'common.field.id' | translate,
                  text: load.pickupExtId
                },
                {
                  label: 'monitoring.transports.loadView.name' | translate,
                  text: load.pickupName
                },
                {
                  label: 'common.field.address' | translate,
                  text: load.pickupAddress
                }
              ]
            },
            {
              title: 'monitoring.transports.loadView.delivery' | translate,
              rows: [
                {
                  label: 'common.field.id' | translate,
                  text: load.deliveryExtId
                },
                {
                  label: 'monitoring.transports.loadView.name' | translate,
                  text: load.deliveryName
                },
                {
                  label: 'common.field.address' | translate,
                  text: load.deliveryAddress
                }
              ]
            }
          ]
        "
      >
        <ui-info-field-list
          class="flat-info-field-list"
          [title]="item.title"
          [rows]="item.rows"
          [flat]="true"
        ></ui-info-field-list>
      </ng-container>
    </div>
  </div>
  <mat-accordion *ngIf="load.transportOrders as transportOrders">
    <div
      *ngFor="let transportOrder of transportOrders"
      class="to-item sub-item"
      [ngClass]="
        transportOrder.status === monitoringStatus.Planned
          ? 'planned'
          : transportOrder.status === monitoringStatus.InProgress
          ? 'in-progress'
          : 'delivered'
      "
    >
      <div class="expansion-panel-point"></div>
      <mat-expansion-panel>
        <mat-expansion-panel-header class="tw-flex tw-m-0">
          <mat-panel-title>
            <a
              [routerLink]="'/dashboard/shipment-to/main-info'"
              [queryParams]="{
                transportOrderNumber: transportOrder.toNumber,
                monitoringPageType: monitoringPageType
              }"
            >
              <span class="to-item__number card-item-number sub-item__number">
                {{ 'monitoring.transports.viewMode.transportOrder' | translate }}: {{ transportOrder.toNumber }}</span
              >
            </a>
            <ui-deviation-type
              *ngIf="transportOrder?.deviation as deviation"
              [deviation]="deviation"
            ></ui-deviation-type>
          </mat-panel-title>
          <mat-panel-description class="transport-order-status">
            <ng-container *ngIf="transportOrder.status as status; else notAvailableTemplate">
              {{ status | startCase }}
            </ng-container>
          </mat-panel-description>
          <mat-panel-description class="tw-flex tw-gap-x-8">
            <ui-dates cropText [dates]="transportOrder.dates" [dateType]="dateType.Departure"></ui-dates>
            <ui-dates cropText [dates]="transportOrder.dates" [dateType]="dateType.Arrival"></ui-dates>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="to-details">
          <ng-container
            *ngFor="
              let item of [
                {
                  title: 'monitoring.transports.loadView.details.departure' | translate,
                  rows: [
                    {
                      label: 'monitoring.transports.loadView.details.estimatedTime' | translate,
                      localDate: transportOrder?.dates.estimatedDepartureTime
                    },
                    {
                      label: 'monitoring.transports.loadView.details.delay' | translate,
                      text: transportOrder.departureDelay | delayHours : ('common.field.hour' | translate)
                    },
                    {
                      label: 'common.field.id' | translate,
                      text: transportOrder.shippedFromExtId
                    },
                    {
                      label: 'monitoring.transports.loadView.name' | translate,
                      text: transportOrder.shippedFromName
                    },
                    {
                      label: 'common.field.address' | translate,
                      text: transportOrder.shippedFromAddress
                    }
                  ]
                },
                {
                  title: 'monitoring.transports.loadView.details.arrival' | translate,
                  rows: [
                    {
                      label: 'monitoring.transports.loadView.details.estimatedTime' | translate,
                      localDate: transportOrder?.dates.estimatedArrivalTime
                    },
                    {
                      label: 'monitoring.transports.loadView.details.delay' | translate,
                      text: transportOrder.arrivalDelay | delayHours : ('common.field.hour' | translate)
                    },
                    {
                      label: 'common.field.id' | translate,
                      text: transportOrder.shippedToExtId
                    },
                    {
                      label: 'monitoring.transports.loadView.name' | translate,
                      text: transportOrder.shippedToName
                    },
                    {
                      label: 'common.field.address' | translate,
                      text: transportOrder.shippedToAddress
                    }
                  ]
                }
              ]
            "
          >
            <ui-info-field-list
              class="flat-info-field-list"
              [title]="item.title"
              [rows]="item.rows"
              [flat]="true"
            ></ui-info-field-list>
          </ng-container>
        </div>
      </mat-expansion-panel>
    </div>
  </mat-accordion>
</mat-card>

<ng-template #notAvailableTemplate>
  {{ notAvailable }}
</ng-template>
